"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var ProductSuppliers_1 = require("../model/ProductSuppliers");

var ProductSuppliersConverter_1 = require("./ProductSuppliersConverter");
/**
 *
 * Implementation of {@link ProductSuppliersConverter}
 * @author Adam Drda
 */


var ProductSuppliersConverterImpl =
/*#__PURE__*/
function (_ProductSuppliersConv) {
  _inherits(ProductSuppliersConverterImpl, _ProductSuppliersConv);

  function ProductSuppliersConverterImpl() {
    _classCallCheck(this, ProductSuppliersConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSuppliersConverterImpl).apply(this, arguments));
  }

  _createClass(ProductSuppliersConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductSuppliers_1.ProductSuppliers(ProductSuppliers_1.ProductSuppliers.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ProductSuppliers_1.ProductSuppliers.schema.preferredSupplierId.valueOf(utils_1.Utils.isValueMissing(source.preferredSupplierId) ? null : conversions.toClassReferenceId(source.preferredSupplierId)), ProductSuppliers_1.ProductSuppliers.schema.supplierIds.valueOf(conversions.asClassReferenceIdsSet(source, 'supplierIds')));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        preferredSupplierId: utils_1.Utils.isValueMissing(source.preferredSupplierId) ? null : conversions.toDocumentReferenceId(source.preferredSupplierId),
        supplierIds: conversions.asObjectArray(source, 'supplierIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        })
      });
      return result;
    }
  }]);

  return ProductSuppliersConverterImpl;
}(ProductSuppliersConverter_1.ProductSuppliersConverter);

exports.ProductSuppliersConverterImpl = ProductSuppliersConverterImpl;